import { athletesModule } from '@modules/athletes/desktop/module';
import { attendanceModule } from '@modules/attendance/desktop/module';
import { baseModule } from '@modules/base/desktop/module';
import { medicalModule } from '@modules/medical/desktop/module';
import { physioModule } from '@modules/physio/desktop/module';
import { trainersModule } from '@modules/trainers/desktop/module';
import type { PlatformModule } from '@/platform/modules';

/**
 * All modules compiled into this build, lowest layer first. Which are *installed* is decided per organization by the backend
 * (the bootstrap lists them). A new module (trainers, nutrition, ...) is one line here.
 */
export const ALL_MODULES: PlatformModule[] = [baseModule, athletesModule, physioModule, attendanceModule, medicalModule, trainersModule];
